export const educationData = [
    
    {
        id: 1,
        institution: 'GKM Vidyashram Sr. Sec. School',
        course: 'Primary School',
        startYear: '2010',
        endYear: '2017'
    },
    {
        id: 2,
        institution: 'Zion Matriculation School',
        course: 'Higher Secondary Education',
        startYear: '2017',
        endYear: '2019'
    },
    {
        id: 3,
        institution: 'Loyola-ICAM College of Engineering and Technology',
        course: 'Bachelor of Technology',
        startYear: '2019',
        endYear: '2023'
    },
]